module.exports = __webpack_public_path__ + "img/hot-mini.e41803f3.png";